module.exports = __webpack_public_path__ + "static/img/DetailLine.0e1755b5.png";